import { FC } from "react";

import { IRideDto } from "@ryde/shared";

import { VehicleOccupancyRides } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const VehicleOccupancyCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
}) => {
  return <VehicleOccupancyRides rideDto={rowOriginal as IRideDto} />;
};
